export default __webpack_public_path__ + "static/media/sacredfire.0e182018.png";